export default __webpack_public_path__ + "static/media/mail.6b17b730.svg";